import { useRef, useEffect, useState } from 'react';
import { ViewObserver } from './observer';
import { ViewObserverPreset } from './preset';
export const useViewObserver = (props, deps = []) => {
    const { onView, ref: inputRef, options } = props;
    const ref = inputRef || useRef(null);
    const [tracked, setTracked] = useState(false);
    useEffect(() => {
        const element = ref.current;
        if (!element || tracked) {
            return;
        }
        const observer = ViewObserver.Factory.get(options || ViewObserverPreset.default);
        observer.observe(element, (visible) => {
            if (visible) {
                onView();
                setTracked(true);
                observer.unobserve(element);
            }
        });
        return () => {
            observer.unobserve(element);
        };
    }, [ref, tracked, onView, ...deps]);
    return ref;
};
